export const workspace = [
  {
    description: 'Run Global Amendments',
    url: '/Diary/GlobalAmendments/New',
    permissionLabel: 'Global Amendments',
    actionReference: 'DIARY_GLOBAL_AMENDMENTS',
  },
];
